import * as Sentry from '@sentry/react';

export const InitSentry = () => {
  Sentry.init({
    environment: 'production',
    dsn: 'https://d2421c43faea4f1da300f54e2d0f1720@o28638.ingest.sentry.io/6605028',
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
};
